export interface PaletteSiteContext {
  id: number;
  domain: string;
  status: string;
  originServer: string;
  hostname?: string;
}

const SITE_KEY = 'global-palette.site-context';

export function loadSiteContext(): PaletteSiteContext | null {
  try {
    const raw = localStorage.getItem(SITE_KEY);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed.id !== 'number' || typeof parsed.domain !== 'string') {
      return null;
    }
    return {
      id: parsed.id,
      domain: parsed.domain,
      status: String(parsed.status || ''),
      originServer: String(parsed.originServer || ''),
      hostname: parsed.hostname ? String(parsed.hostname) : undefined,
    };
  } catch {
    return null;
  }
}

export function saveSiteContext(site: PaletteSiteContext | null): void {
  try {
    if (!site) {
      localStorage.removeItem(SITE_KEY);
      return;
    }
    localStorage.setItem(SITE_KEY, JSON.stringify(site));
  } catch {
    // ignore
  }
}

export function siteStatusTone(status: string): 'success' | 'error' | 'warn' | 'info' | 'muted' {
  const s = (status || '').toUpperCase();
  if (s === 'ACTIVE') {
    return 'success';
  }
  if (s === 'ERROR') {
    return 'error';
  }
  if (s === 'DISABLED') {
    return 'warn';
  }
  if (s === 'PENDING') {
    return 'info';
  }
  return 'muted';
}
